import { Component, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { MealTimesService } from 'src/app/Services/meal-times.service';

import * as moment from 'moment';
import { Time } from '@angular/common';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type MealTimes = {
  aiiActivityName: string;
  aiiActivityDesc: string;
  aiibegtime: Time;
  aiiendtime: Time;

  aiiLocationName: string;
  aiiDisplayLocationName: string;
  slnName: string;
  dplDeck: string;
  dpluid: Int16Array;
};

@Component({
  selector: 'app-dining-times',
  templateUrl: './dining-times.component.html',
  styleUrls: ['./dining-times.component.css'],
  providers: [MealTimesService],
  encapsulation: ViewEncapsulation.None,
})
export class DiningTimesComponent {
  userdata?: UserData;
  evtCode: string | undefined;
  OBPortalSvcURL = '';

  MealtimesInfo: MealTimes[] | undefined;
  mealtimedata: any;
  asofdate: string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    private MealTimesService: MealTimesService
  ) {
  }

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.asofdate = moment().format('YYYY-MM-DD');

    this.getMealTimes();
  }

  getMealTimes() {
    this.mealtimedata = this.MealTimesService.getMealTimes(
      this.evtCode,
      this.asofdate
    ).subscribe((mealtimedata) => this.setMealTimes(mealtimedata));
  }

  setMealTimes(resdata: any) {
    this.mealtimedata = resdata;
    if (this.mealtimedata.GetMealTimes.Result.Status == 'A') {
      this.MealtimesInfo = this.mealtimedata.GetMealTimes.MealTimeList;
    }
  }
}
